import { ROLES } from '..';
import { UserApi } from '../../../common/constants/user-api';
import getCookie, {
  COOKIE_MH_TOKEN,
  COOKIE_PERSONA_ROLE,
  COOKIE_PERSONA_SEGMENT,
  COOKIE_USEREMAIL,
  COOKIE_USERNAME,
  removeCookie,
} from '../../../common/cookies';
import { isLocalEnv } from '../../../common/environment';
import policy from '../../../common/policy';
import { UserProfile } from '../user-profile.interface';

const SEGMENTS: { [key: string]: string } = {
  HE: 'HE',
  SEG: 'K12ECOMMERCE',
};

export async function checkValidityOfToken(mhToken: string) {
  const url = new URL(UserApi.getUserDetail);
  if (!mhToken) {
    throw new Error('Token not provided.');
  }

  return await fetch(
    new Request(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${mhToken}`,
      },
    })
  )
    .then((res) => {
      if (res.ok) {
        return res.json();
      }
      throw new Error('Token invalid.');
    })
    .catch((err) => {
      throw err;
    });
}

export async function getUserProfileApiCall(checkSelfOptOut?: boolean) {
  const url = new URL(UserApi.getUserDetail);
  if (checkSelfOptOut) {
    url.searchParams.set('checkSelfOptOut', 'true');
  }

  return await fetch(
    new Request(url.toString(), {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
    })
  ).then((res) => {
    if (res.ok) {
      return res.json();
    } else if (res.status === 401 && !policy.deniedCookies()) {
      const hasMHTokenCookie = getCookie(COOKIE_MH_TOKEN);

      if (hasMHTokenCookie) {
        removeCookie(COOKIE_MH_TOKEN);
      }

      // This is needed as a fallback in case the old shop authentication is used instead of the new JWT authentication.
      // The only place this is used is the instructor sampling flow: https://shop.mheducation.com/store/services/loginview?flow=sampling&isbn=9781264071227
      // This can be removed once all login and registration is on Heclr: https://mheducation.slack.com/archives/C02J6CGKDPA/p1656014458493079
      const givenName = getCookie(COOKIE_USERNAME);
      if (givenName) {
        const cookieBasedProfile: UserProfile = {
          affiliations: [
            {
              orgCountry: '',
              orgCity: '',
              orgName: '',
              orgXid: '',
              role: ROLES[getCookie(COOKIE_PERSONA_ROLE)] || '',
              segment: SEGMENTS[getCookie(COOKIE_PERSONA_SEGMENT)] || '',
            },
          ],
          persona: {
            role: ROLES[getCookie(COOKIE_PERSONA_ROLE)]?.toUpperCase() || '',
            segment: SEGMENTS[getCookie(COOKIE_PERSONA_SEGMENT)] || '',
          },
          email: getCookie(COOKIE_USEREMAIL) || '',
          familyName: '',
          givenName: getCookie(COOKIE_USERNAME) || '',
          phone: '',
          question: '',
          sources: [],
          userType: ROLES[getCookie(COOKIE_PERSONA_ROLE)] || '',
          xid: '',
          isSelfOptOutEnabled: false,
        };

        return cookieBasedProfile;
      } else {
        if (isLocalEnv()) {
          throw new Error('Error loading profile: ' + res.status);
        }
      }
    } else {
      if (isLocalEnv()) {
        throw new Error('Error loading profile: ' + res.status);
      }
    }
  });
}
